<template>
    <div>
        <el-form :inline="true" :model="queryParams"  class="demo-form-inline" size="small" style="text-align: left;margin-top: 5px">
            <el-form-item label="商品名称">
                <el-input v-model="queryParams.productName" placeholder="请输入商品名称" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="mini" @click="getCategoryList()">查询</el-button>
                <el-button icon="el-icon-refresh" size="mini" @click="resetQuery()">重置</el-button>
            </el-form-item>

        </el-form>
        <el-row :gutter="10" class="mb8">
            <!-- v-if="shopId==0" -->
            <el-col :span="1.5">
                <el-button
                        type="primary"
                        plain
                        icon="el-icon-plus"
                        size="mini"
                        @click="addButton()"
                >添加商品</el-button>
            </el-col>
            <el-col :span="1.5">
                <el-button
                        type="danger"
                        plain
                        icon="el-icon-delete"
                        size="mini"
                        :disabled="isDelete"
                        @click="delList"
                >删除</el-button>
            </el-col>

        </el-row>
        <el-table
                :data="list"
                style="width: 100%;margin-bottom: 20px;line-height: 0"
                @selection-change="handleSelectionChange"
                row-key="productId"
                show-header
                border>
            <el-table-column type="selection" width="55" align="center" :reserve-selection="true"></el-table-column>
            <el-table-column label="商品名称" align="center" prop="productName" :show-overflow-tooltip="true" width="180" />
            <el-table-column label="图片" align="center" prop="productImage" width="120" >
                <template slot-scope="scope">
                    <el-image
                            style="width: 80px; height: 80px;border-radius: 10px;"
                            :src="scope.row.productImage"></el-image>
                </template>
            </el-table-column>
            <el-table-column label="商品类型" align="center" prop="productCategoryName" />
            <el-table-column label="商品价格" align="center" prop="productPrice">
                <template slot-scope="scope">
                    <span style="color: red">￥{{scope.row.productPrice.toFixed(2)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="商品简介" align="center" prop="productBrief" :show-overflow-tooltip="true"/>
            <el-table-column label="已售" align="center" prop="productCount" />
            <el-table-column label="显示顺序" align="center" prop="sortNum" width="80"  sortable />
            <el-table-column label="状态"  align="center" width="100">
                <template slot-scope="scope">
                    <el-tag type="success" v-if="scope.row.status=='0'">上架</el-tag>
                    <el-tag type="warning" v-if="scope.row.status=='1'">下架</el-tag>
                </template>
            </el-table-column>

            <el-table-column label="创建时间" align="center" prop="createTime" sortable>
                <template slot-scope="scope">
                    <span>{{ scope.row.createTime | dateFormat}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                    <el-button
                            size="mini"
                            type="text"
                            icon="el-icon-edit"
                            @click="modifyButton(scope.row)"
                    >修改</el-button>
                    <el-button
                            size="mini"
                            type="text"
                            icon="el-icon-delete"
                            @click="delList(scope.row)"
                    >删除</el-button>
                </template>

            </el-table-column>
        </el-table>
        <template v-if="list.length!=0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryParams.pageNum" :page-sizes="[1, 2, 5, 10]"
                           :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </template>
        <!-- 添加或修改用户配置对话框 -->
        <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body destroy-on-close>
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                <el-divider content-position="left">基本信息</el-divider>
                <el-row>
                    <el-form-item label="商品名称" prop="productName">
                        <el-input v-model="form.productName" placeholder="请填写商品名称" maxlength="20" />
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="商品说明" prop="productBrief">
                        <el-input v-model="form.productBrief" placeholder="请填写商品说明" maxlength="20" />
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="商品类型" prop="shopCategoryName">
                            <span slot="label">
                                <el-tooltip content="请选择好商品的类型，此空将决定你的店铺在那种类型中显示" placement="top">
                                    <i class="el-icon-question"></i>
                                </el-tooltip>
                                类型
                            </span>
                            <el-select v-model="form.foodProductCategoryId" filterable placeholder="请选择">
                                <el-option
                                        v-for="item in typeList"
                                        :key="item.id"
                                        :label="item.shopCategoryName"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-form-item label="商品图片" prop="productImage">
                        <el-upload
                                class="upload-demo"
                                :action="uploadUrl"
                                :on-success="handleSuccess"
                                :on-remove="handleRemove"
                                list-type="picture">
                            <el-button size="small" type="primary">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
                        </el-upload>
                    </el-form-item>
                </el-row>
                <el-divider content-position="left">参数配置</el-divider>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="显示顺序" prop="sortNum">
                            <el-input-number v-model="form.sortNum" controls-position="right" :min="0"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="状态">
                            <el-radio-group v-model="form.status">
                                <el-radio label="0">上架</el-radio>
                                <el-radio label="1">下架</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="价格" prop="productPrice">
                            <el-input v-model="form.productPrice" placeholder="请输入" maxlength="3">
                                <template slot="append">元</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="已售" prop="productCount">
                            <el-input v-model="form.productCount" placeholder="请输入" maxlength="5">
                                <template slot="append">份</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="cancel">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                //店铺id
                shopId:0,
                //图片上传接口
                uploadUrl:'http://127.0.0.1:8080/upload',
                //类型集合
                typeList:[],
                isDelete:true,
                form: {
                    productId:0,
                    productName:'',
                    productImage:'',
                    productBrief:'',
                    productCount:'',
                    productPrice:'',
                    status:'0',
                    foodProductCategoryId:'',
                    sortNum:'',
                    shopId:'',
                },
                open:false,
                title: "",
                list: [],//菜单
                //加载状态
                loading: false,
                total: 0,
                //查询数据
                queryParams: {
                    pageNum: 1,
                    pageSize: 10,
                    productName:"",
                    shopId:0,
                },
                rules: {

                    productName: [
                        {required: true, message: '请填写商品名称', trigger: 'blur'},
                        {min:2,max: 8, message: '铺分类名称需在2~12个字符', trigger: 'blur'},
                    ],

                },
                selectedRows: [],
                status:[
                    {
                        id:0,
                        value:"营业",
                    },
                    {
                        id:1,
                        value:"停业",
                    }
                ],

            }
        },
        mounted() {
            this.getCategoryList();
            this.getProductTypeByShopId();
        },
        created(){
            //获取缓存中的shopId
            this.shopId=window.sessionStorage.getItem("shopId");
        },
        methods: {
            //获取当前店铺下的所有商品类型
            async getProductTypeByShopId() {
                const {data: res} = await this.$http.get("productCategory/getProductCategoryByShopId", {
                    params: {
                        shopId: this.shopId
                    }
                })
                this.typeList=res.data;
            },
            handleRemove(file, fileList) {
                console.log(file.response.data);
                //删除上传的图片
                const {data:res}= this.$http.get("/deleteFile",{params:{
                        imgUrl:file.response.data
                    }})
            },
            handleSuccess(file) {
                console.log(file);
                this.form.productImage=file.data;
            },
            //获取所有学校
            async getSchoolList() {
                const {data: res} = await this.$http.get("school/getSchools");
                console.log(res)
                this.schoolList = res.data;
            },
            //删除
            async delList(row) {
                if (row.productId){
                    this.selectedRows=[];
                    this.selectedRows.push(row.productId);
                }
                console.log(this.selectedRows)
                this.$confirm('此操作将永久删除角色, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(async ()=>{
                    const {data: res} = await this.$http.post("product/delProduct", this.selectedRows)
                    if (res.code == 200) {
                        this.$message.success('删除成功')
                        this.getCategoryList();
                    }else {
                        this.$message.error('服务器异常或尝试稍后再试！')
                    }
                }).catch((e) => {
                    this.$message.info('已取消删除！')
                })

            },
            /**
             * 修改按钮操作
             * */
            modifyButton(rowData){
                this.title="更新店铺";
                this.form=rowData;
                this.open=true;
            },
            cancel(){
                this.reset();
                this.open=false;
            },
            reset(){
                this.form={
                    productId:0,
                    productName:'',
                    productImage:'',
                    productBrief:'',
                    productCount:'',
                    productPrice:'',
                    status:'0',
                    foodProductCategoryId:'',
                    sortNum:'',
                    shopId:'',
                }
            },
            /**修改用户*/
            async modifyFrom() {
                const {data: res} = await this.$http.post('product/updateProduct',JSON.parse(JSON.stringify(this.form)));
                if (res.code==200){
                    this.$message.success('商品成功')
                    this.getCategoryList();
                }else if(res.code==50003){
                    this.$message.error('商品已存在！')
                }else {
                    this.$message.error('服务器异常')
                }
            },
            /**
             * 添加用户
             * */
            async addFromFun() {
                const {data: res} = await this.$http.post('shop/insertShop', JSON.parse(JSON.stringify(this.form)));
                console.log(res)
                if(res.code==200){
                    this.$message.success('商品添加成功！')
                    this.getCategoryList();
                }else if(res.code==50003){
                    this.$message.error('此商品已存在,请切换一个商品名称!')
                }else{
                    this.$message.error('服务器异常')
                }
            },
            /** 提交按钮 */
            async submitForm() {
                //获取缓存中的店铺id
                this.form.shopId=window.sessionStorage.getItem("shopId");
                console.log(this.form)
                await this.$refs["form"].validate(valid => {
                    if (valid) {
                        if (this.form.productId != 0) {
                            this.modifyFrom();
                        } else {
                            this.addFromFun();
                        }
                    }
                });
                this.open = false;
            },
            //添加按钮操作
            addButton(){
                this.title="添加商品";
                this.reset();
                this.open=true;
            },
            //重置
            resetQuery(){
                this.queryParams= {
                    pageNum: 1,
                    pageSize: 10,
                    productName:"",
                    shopId: 0,
                }
                this.getCategoryList();
            },
            /**
             * 获取多选ids
             * **/
            handleSelectionChange(rows) {
                const newArr = []
                rows.forEach((item) => {
                    newArr.push(item.productId)
                });
                this.selectedRows = newArr;
                console.log(this.selectedRows)
                if (this.selectedRows.length!=0){
                    this.isDelete=false;
                }else {
                    this.isDelete=true;
                }
            },
            /**
             * 获取分类列表
             * @returns {Promise<void>}
             */
            async getCategoryList() {
                this.queryParams.shopId=this.shopId;
                const {data: res} = await this.$http.get("product/getProductAndShopName", {params:this.queryParams});
                console.log(res)
                this.list=res.data.children;
                // console.log(this.list)
                this.total=res.data.total;
            },
            handleSizeChange(val) {
                this.queryParams.pageSize=val;
                this.getCategoryList();
            },
            handleCurrentChange(val) {
                this.queryParams.pageNum=val;
                this.getCategoryList();
            }
        },
    }

</script>

<style scoped>

</style>
